import $http from '@/resource';
import utils from '@/utils';

const $api = {};

/**
 * 获取项目进度
 *
 * @param {string} companyId 单位did
 * @param {string} type 类型1：土地 2：厂房 3:商业 4：写字楼 5：注册 7：仓库 10：其他
 *
 * @returns {Promise<any>}
 */
$api.getItemManage = (companyId, type)=>{
    const url = `company/${companyId}/item-progress?type=${type}`;
    const promise = new Promise(resolve=>{
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 更新项目进度管理
 *
 * @param {string} companyId 单位id
 * @param {object} data 待更新的数据
 *
 * @returns {Promise<any>}
 */
$api.updateItemManage = (companyId, data)=>{
    const url = `company/${companyId}/item-progress`;
    const promise = new Promise(resolve=>{
        $http.put(url, data).then(response=>{
            // if (response.code === "200") {
            //     utils.message({title: response.msg}, 'success');
                resolve(response);
            // } else {
            //     utils.message({title: response.msg}, 'error');
            // }
        });
    });
    return promise;
};

/**
 * 删除项目进度管理
 *
 * @param {string} companyId 单位id
 * @param {string} id 待删除数据id
 *
 * @returns {Promise<any>}
 */
$api.deleteItemManage = (companyId, id)=>{
    const url = `company/${companyId}/item-progress`;
    const promise = new Promise(resolve=>{
        $http.post(url,{id:id}).then(response=>{
            // if (response.code === "200") {
            //     utils.notice(response.msg, 'success');
                resolve(response);
            // } else {
            //     utils.notice(response.msg, 'error');
            // }
        });
    });
    return promise;
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/itemManage.js